var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerXl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 20C38 23.5601 36.9443 27.0402 34.9665 30.0003C32.9886 32.9603 30.1774 35.2675 26.8883 36.6298C23.5992 37.9922 19.98 38.3487 16.4884 37.6541C12.9967 36.9596 9.78942 35.2453 7.27208 32.7279C4.75473 30.2106 3.0404 27.0033 2.34586 23.5116C1.65133 20.02 2.00779 16.4008 3.37017 13.1117C4.73255 9.82263 7.03965 7.01141 9.99974 5.03355C12.9598 3.05568 16.4399 2 20 2V5.6C17.1519 5.6 14.3679 6.44454 11.9998 8.02684C9.63172 9.60913 7.78604 11.8581 6.69613 14.4894C5.60623 17.1206 5.32106 20.016 5.87669 22.8093C6.43232 25.6026 7.80379 28.1685 9.81766 30.1823C11.8315 32.1962 14.3974 33.5677 17.1907 34.1233C19.984 34.6789 22.8794 34.3938 25.5106 33.3039C28.1419 32.214 30.3909 30.3683 31.9732 28.0002C33.5555 25.6321 34.4 22.8481 34.4 20H38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerXl);
export default __webpack_public_path__ + "static/media/spinner-XL.81532d6ac3451817b65c29855dac9a82.svg";
export { ForwardRef as ReactComponent };